import { jsx } from "react/jsx-runtime";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { validateTidalLicense } from "../../base/index.js";
function DirectionsCar(props) {
  return /* @__PURE__ */ jsx(
    DirectionsCarIcon,
    {
      "data-testid": "DirectionsCar",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "DirectionsCar",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
DirectionsCar.tidalIconMeta = {
  categories: "miscellaneous",
  name: "DirectionsCar"
};
validateTidalLicense();
export {
  DirectionsCar
};
//# sourceMappingURL=DirectionsCar.js.map
